export const habaCheckout = {
  habaOrderSummary: {
    subTotal: 'Warenwert',
    shipping: 'Versandkosten',
    totalDiscounts: 'Rabatte',
    total: 'Gesamtsumme',
    totalSavings: 'Total savings:',
    safeSSL: 'Ihre Daten werden durch SSL-Verschlüsselung sicher übertragen.',
    help: 'Benötigen Sie Hilfe?',
    giftCard: 'Gutschein*',
    giftCardsResidualValue: 'residual gift card',
    subHelp1: 'Kontaktieren Sie',
    subHelp2: 'hier unseren Kundenservice',
    btn: {
      label_0: 'Address',
      label_1: 'Delivery',
      label_2: 'Weiter zur Zahlungsart',
      label_3: 'Weiter zur Übersicht',
    },
    orderNote: {
      title: 'Note',
      placeholder: 'You can leave important information about your order in the comments field.',
      label: '',
      error: '',
      wordCount: 'Remaining characters: {{count}}',
      save: 'Save comment',
    },
  },
  habaConfirmation: {
    customerConfirmationTitle: 'Change selection?',
    customerConfirmationMessage: 'If you change your selection, the data you have already entered will be lost. Do you want to continue anyway?',
    customerConfirmationAcceptBtnMessage: 'Continue',
    thankYouHeading: 'Thank you for your order',
    thankYouText:
      'You will receive confirmation of your order and further information on the right of withdrawal and return by email to the following address:',
    pendingRegistrationReminderText:
      'Please confirm your email address, then we can create your customer account. We have sent you an email. Just click the confirmation link in the email.',
    total: 'Total amount of order',
    haveOneSecond: 'A few more seconds?',
    pleaseConfirm: 'Confirm your e-mail address',
    securityPartOne: 'To ensure the security of your customer account, we sent an email to ',
    securityPartTwo: '.',
    confirmationLink: 'Click the confirmation link in the email to finish setting up your account.',
    accountDeletion:
      'You can only use your customer account after the e-mail address has been confirmed! Otherwise, for security reasons, the customer account will be deleted after 2 weeks.',
    myAccountRedirectMessage:
      'You can view the status of your order and shipment tracking (as soon as available) at any time in your user account under "<a href="{{myOrders}}">My order overview</a>".',
    myAccountAfterConfirmMessage:
      'After confirming your customer account, you can view the status of your order and the shipment tracking (as soon as available) in your user account under "My order overview".',
    orderDetailsRedirectGuestMessage:
      'You can view the status of your order and shipment tracking (as soon as available) at any time in the <strong><a href="{{myOrders}}">order overview</a></strong>.',
    infoBoxMessage:
      'Please check the specified delivery date on your order confirmation. Please contact us if your order is intended for a <b>facility and</b> the <b>delivery date falls within your closing times.</b>',
  },
  habaPayment: {
    description: {
      advancePayment:
        'Sie erhalten eine separate <strong>Auftragsbestätigung/Rechnung</strong> mit weiteren Zahlungsinformationen.',
      ct_creditcard_hop:
        'Sie werden nach dem Absenden der Bestellung zur Kreditkartenzahlung (HOP hosted order page) weitergeleitet.',
      ct_paypal:
        'Mit PayPal bezahlen ist einfach, schnell und sicher! Hinweis: Die Abfrage Ihrer Daten erfolgt nach dem Absenden der Bestellung. Sie müssen Ihre PayPal-Daten bei jedem Einkauf neu eingeben. Beim Bezahlen per PayPal wird auf die Website von PayPal weitergeleitet. Hierfür gelten die AGB von PayPal.',
      invoice:
        'Sie zahlen den Rechnungsbetrag ganz bequem per Überweisung innerhalb von 14 Tagen. Wir senden Ihnen die Rechnung vorzugsweise per E-Mail zu (PDF-Anhang). Zum Zwecke der Bonitätsprüfung können wir Ihre zur Adress- und Bonitätsprüfung erforderlichen Daten gegen die von der CRIF Bürgel GmbH gespeicherten Daten abgleichen. Die dort gespeicherten Daten beziehen auch Erkenntnisse aus mathematisch-statistischen Verfahren ein. Näheres hierzu können Sie unter diesem <a href="https://www.crif.de/datenschutz" target="_blank" rel="noopener noreferrer">Link</a> abrufen.',
    },
    disabledGiftcard: 'this payment method cannot be used together with a gift card',
    paymentMethod: 'Payment Method',
    paymentMethodEditState: 'Edit Payment',
    personalDataEditState: 'Personal Data',
    selectionError: 'Please select a payment method.',
    button: 'Next',
    buttonEditState: 'Update payment method',
    disabledPaymentMethods: {
      ct_creditcard_hop:
        'Unfortunately, we can not currently offer purchase by credit card. Please choose an alternative payment method.',
      ct_paypal:
        'Unfortunately, we can not currently offer purchase via PayPal. Please choose an alternative payment method.',
      invoice:
        'Unfortunately, we can not currently offer purchase on account. Please choose an alternative payment method.',
      advancePayment: 'Please note that the payment method "prepayment" cannot be used in conjunction with vouchers.',
    },
    disabledDescription: {
      ct_paypal:
        'You have products in your shopping cart that are produced for you. Here we can currently only offer you invoice or prepayment as payment methods.',
      ct_creditcard_hop:
        'You have products in your shopping cart that are produced for you. Here we can currently only offer you invoice or prepayment as payment methods.',
    },
    birthdateModal: {
      title: 'Please prove your identity',
      paragraph:
        'For this payment method we need additional data to prove your identity. You can then complete your purchase.',
      dataProtection: 'Data protection',
      inputPlaceholder: 'Birthday (dd.mm.yyyy)',
      submitButton: 'Confirm',
      dataProtectionLink: 'Data protection',
      dataProtectionText: 'Conditons applied',
    },
    giftcardRedemptionDisabledTitle: 'Gift cards cannot be redeemed with prepayment',
    giftcardRedemptionDisabledDescription: 'Please select a different payment method if you wish to redeem a gift card.',
    giftcardRedemptionDisabledButton: 'Proceed without gift card',
    giftcardRedemptionDisabledButtonSubmit: 'Change payment method'
  },
  habaPlaceOrder: {
    agb: 'Ja, ich stimme den AGB zu.',
    dataProtection: 'Unsere Datenschutzerklärungen finden Sie hier.',
    placeOrder: 'Buy Now',
    error: 'An error has occurred.',
  },
  habaGuestLogin: {
    next: 'Continue',
    title: 'I am a new customer in the online shop',
    heading: 'Als Gast bestellen',
    emailAddress: {
      label: 'E-Mail Adresse',
      error: 'Bitte geben Sie eine gültige E-Mail Adresse ein.',
    },
    emailConfirmationAddress: {
      label: 'E-Mail Adresse bestätigen',
      error: 'Bitte geben Sie eine gültige E-Mail Adresse ein.',
    },
    button: 'Zur Gastbestellung',
  },
  habaCheckoutProgress: {
    login: 'Login',
    methodOfPayment: 'Method of Payment',
    billingAddress: 'Billing Address',
    shippingAddress: 'Shipping Address',
    address:'Address',
    customerData:'Customer Data',
    deliveryMode: 'Delivery Mode',
    paymentDetails: 'Payment Details',
    authorizePayment: 'Authorize Payment',
    reviewOrder: 'Review Order',
  },
  habaCheckoutReview: {
    pendingRegistration: {
      title: 'Your new registration is still being processed',
      durationBefore: 'This can take',
      duration: 'up to one working day',
      durationAfter:
        'to complete. You will receive a confirmation email as soon as processing is complete.',
      impactTitle: 'What does this mean for your order?',
      noConditions:
        'There are no restrictions for new business customers or companies without individual conditions.',
      existingConditions:
        'If individual company conditions or framework agreements already exist, they will only be available after confirmation.',
      orderNow:
        'You can order now at the conditions shown or wait for the confirmation email.',
    },
    review: 'Your summary',
    cardTitle: {
      shippingAddress: 'Delivery Address',
      billingAddress: 'Billing Address',
      contactPerson: 'Contact Person for Delivery',
      client:'Client',
      clientContactPerson:'Contact Person for Client',
      emailInvoice: 'Email address for the invoice',
      paymentMethod: 'Payment',
      deliveryMethod: 'Delivery',
    },
    default: 'Default',
    errors: {
      syncAtpCheckProductNotAvailable:
        'Stock not available anymore. One or more products have been removed from your cart.',
      syncAtpCheckProductQuantityChanged:
        'Stock not available anymore. One or more products had their quantities lowered.',
      generic: 'Order can not be finalised. Please try again later or contact our support team',
      syncAtpCheckProductNotAvailableQuantityChanged:
        'Stock not available anymore. One or more products have been removed from your cart & one or more products had their quantities lowered',
      cartItemsPriceChanged: 'Product prices have been updated. Please check your order again',
      giftCardsRemoved: 'One or more Gift cards have been removed. Please add them again',
      invalidPaymentDetails: 'Please update your payment method.',
      companyAddressesChanged: 'Your company data has changed. Please select your addresses again.',
      purchaseGiftcardsAndRedemption:
        'Voucher redemption has been removed. Vouchers cannot be used as a payment method when purchasing gift cards.',
    },
  },
  habaCheckoutFooter: {
    infoservice: {
      headline: 'KUNDENSERVICE',
      schedule: 'Montag - Freitag 8-16 Uhr',
      telephone: {
        DE: '+49 9564 929 60013',
        AT: '+43 732 210 002',
      },
      email: 'kontakt@wehrfritz.com',
    },
    orderservice: {
      headline: 'BESTELLSERVICE',
      schedule: 'Montag - Freitag 8-16 Uhr',
      telephone: {
        DE: '+49 9564 929 60316',
        AT: '+43 732 210 001'
      },
      email: 'bestellungen@wehrfritz.com',
    },
    contact: {
      headline: 'KONTAKT',
      text: 'Kontaktformular',
    },
    information: {
      headline: 'HINWEISE',
      text: 'Alle Angaben in EUR, inkl. MwSt. zzgl. Versand- und Servicekosten.',
    },
    orderInformation: {
      headline: 'BESTELLHINWEISE',
      text: 'Kein Mindestbestellwert. Bitte beachten Sie, dass die Artikel in ihrem Einkaufskorb nicht reserviert sind.',
    },
    links: {
      cookieSettings: 'Cookie-Settings',
      gtc: 'Conditions of Use',
      imprint: 'Imprint',
      privacyNotice: 'Privacy Notice',
    },
  },
};
